/* eslint-disable react/display-name */
import React, { useEffect, useState } from "react";
import { List } from "react-window";
import { useChowdeckProductLink } from "./useChowdeckProductLink";
import styles from "./styles.module.scss";
import primaryComponents from "../../../../primaryComponents";
import {
  ArrowRight,
  ChowdeckIcon,
  LumiIcon,
  SquareupIcon,
} from "../../../../../assets/svgIcons";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../routes/pathContants";
import { RoutedModal } from "../../../../common";
import SuccessConnectionModal from "../SuccessConnectionModal";
import { convertToTilteCase } from "../../../../../helpers";
import { PRICE_RECORDING_OPTIONS } from "../../../../../helpers/constants";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";

export const ChowdeckProductLink = ({
  mappedUnmappedProducts = {},
  lumiProductList = [],
  isEditMode = false,
  providerKey = "chowdeck",
  storeMappingDetails = {},
}) => {
  const navigate = useNavigate();
  const productList = mappedUnmappedProducts?.marketplace || [];
  const route = {
    chowdeck: pathConstants.APPS_CHOWDECK_CONNECTIONS,
    squareup: pathConstants.APPS_SQUAREUP_CONNECTED_STORE,
  };

  const {
    itemData,
    searchQuery,
    filteredProductList,
    selectedProducts,
    isLoading,
    isSucessView,
    showUnmappedWarning,
    storeMappingSettings,
    isUpdatingSettings,
    handleStoreSettings,
    setStoreMappingSettings,
    setShowUnmappedWarning,
    setIsSucessView,
    setSelectedProducts,
    setSearchQuery,
    handleMapping,
  } = useChowdeckProductLink({
    isEditMode,
    productList,
    lumiProductList,
    providerKey,
    storeMappingDetails,
  });

  const selectedPriceRecordingOption = PRICE_RECORDING_OPTIONS.find(
    (option) => option.value === storeMappingSettings?.price_recording_option,
  );

  return (
    <>
      <section>
        <div className={styles.productContainer}>
          <div
            className={`${globalStyles.cardWithBackground} `}
            style={{ gap: "24px" }}
          >
            {providerKey === "chowdeck" ? (
              <div>
                <h6 className="mb-3">Catalog Sync</h6>
                <div
                  className="d-flex align-items-center flex-wrap"
                  style={{ columnGap: "40px", rowGap: "15px" }}
                >
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "10px" }}
                  >
                    <p className="mb-0">Sync Product Name</p>
                    <primaryComponents.Switch
                      name="sync_product_name"
                      id="SYNC_PRODUCT_NAME"
                      isChecked={storeMappingDetails?.sync_product_name}
                      onChange={() => {
                        setStoreMappingSettings((prev) => ({
                          ...prev,
                          sync_product_name:
                            !storeMappingSettings?.sync_product_name,
                        }));
                      }}
                    />
                  </div>

                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "10px" }}
                  >
                    <p className="mb-0">Sync Pricing</p>
                    <primaryComponents.Switch
                      name="sync_product_price"
                      id="SYNC_PRICING"
                      isChecked={storeMappingDetails?.sync_product_price}
                      onChange={() => {
                        setStoreMappingSettings((prev) => ({
                          ...prev,
                          sync_product_price:
                            !storeMappingSettings?.sync_product_price,
                        }));
                      }}
                    />
                  </div>

                  <div style={{ width: "170px" }}>
                    <primaryComponents.InputField
                      label={"Bulk Price Markup (%)"}
                      classNames="white"
                      type="number"
                      placeholder={"Price markup 10%"}
                      value={storeMappingSettings?.price_markup_percentage}
                      onChange={({ target: { value } }) => {
                        setStoreMappingSettings((prev) => ({
                          ...prev,
                          price_markup_percentage: value,
                        }));
                      }}
                      isDisabled={!storeMappingSettings?.sync_product_price}
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {providerKey === "chowdeck" ? <hr className="my-0" /> : null}

            <div>
              <h6 className="mb-3">Order Price Recording</h6>
              <div style={{ maxWidth: "320px" }}>
                <primaryComponents.SelectField
                  label="Record Order Price As"
                  value={
                    selectedPriceRecordingOption?.label ||
                    "Provider's total price"
                  }
                  options={PRICE_RECORDING_OPTIONS}
                  nameKey="label"
                  idKey="value"
                  floatError={false}
                  onChange={(value) => {
                    setStoreMappingSettings((prev) => ({
                      ...prev,
                      price_recording_option: value,
                    }));
                  }}
                />
                {selectedPriceRecordingOption ? (
                  <p className="small-text-size grey--text mt-2 mb-0">
                    {selectedPriceRecordingOption.description}
                  </p>
                ) : null}
              </div>
            </div>

            <hr className="my-0" />

            <div className="d-flex justify-content-end">
              <primaryComponents.Button
                classNames={"btn btn--outline"}
                isDisabled={isUpdatingSettings}
                isLoading={isUpdatingSettings}
                onClick={() => handleStoreSettings()}
                loadingText={"Loading..."}
              >
                Apply To All
              </primaryComponents.Button>
            </div>
          </div>

          <div className={`${styles.productItem}`} style={{ margin: 0 }}>
            <div className="d-flex align-items-center" style={{ gap: "15px" }}>
              <primaryComponents.Checkbox
                name="marketPlaceMappingSelectAll"
                id={"marketPlaceMappingSelectAll"}
                isChecked={selectedProducts?.is_select_all}
                onChange={() =>
                  setSelectedProducts((prev) => ({
                    ...prev,
                    is_select_all: !selectedProducts?.is_select_all,
                  }))
                }
              />

              <div className="d-flex align-items-center">
                {providerKey === "chowdeck" ? (
                  <ChowdeckIcon width={45} height={45} />
                ) : providerKey === "squareup" ? (
                  <SquareupIcon width={45} height={45} />
                ) : null}

                <h6 className="mb-0 ml-2">
                  {convertToTilteCase(providerKey)} items
                </h6>
              </div>
              <primaryComponents.SearchField
                value={searchQuery}
                placeholder={"Search items"}
                triggerOnInput={false}
                showsearchBtn={true}
                isDebounce={true}
                trigger={(value) => setSearchQuery(value)}
              />
            </div>

            <div className={`${styles.select} ml-auto`}>
              <div className="d-flex align-items-center">
                <LumiIcon width={28} height={28} />
                <h6 className="mt-2 ml-2">Lumi Business items</h6>
              </div>
            </div>
          </div>
          <hr />

          <List
            rowComponent={Row}
            rowCount={filteredProductList?.length}
            rowHeight={100}
            rowProps={itemData}
            style={{ height: 600, width: "100%" }}
          />
        </div>
      </section>

      <div className={styles.btnContainer}>
        <primaryComponents.Button
          classNames={"btn btn--outline"}
          onClick={() => {
            navigate(route?.[providerKey]);
          }}
        >
          Back
        </primaryComponents.Button>

        <primaryComponents.Button
          classNames={"btn btn--primary"}
          style={{ width: "150px" }}
          isDisabled={isLoading}
          isLoading={isLoading}
          loadingText={"Saving..."}
          onClick={() => handleMapping()}
        >
          Save
        </primaryComponents.Button>
      </div>

      <RoutedModal
        width={1000}
        isActive={isSucessView}
        closeModal={() => setIsSucessView(false)}
        style={{ height: "auto" }}
        backDropStyle={{ zIndex: "10000" }}
      >
        <SuccessConnectionModal closeModal={() => setIsSucessView(false)} />
      </RoutedModal>

      <RoutedModal
        width={550}
        isActive={showUnmappedWarning}
        closeModal={() => setShowUnmappedWarning(false)}
        headerTitle="Some items are not mapped"
        style={{ height: "auto" }}
        backDropStyle={{ zIndex: "10000" }}
      >
        <p className="mb-4">
          One or more selected items have not been linked to a Lumi Business
          item. Unmapped items will be skipped. Do you want to proceed?
        </p>

        <primaryComponents.Button
          classNames={"btn btn--primary"}
          isDisabled={isLoading}
          isLoading={isLoading}
          loadingText={"Saving..."}
          onClick={() => handleMapping(true)}
        >
          Proceed Anyway
        </primaryComponents.Button>
      </RoutedModal>
    </>
  );
};

const Row = React.memo(
  ({
    index,
    style,
    productList,
    lumiProductList,
    selectedProducts,
    selectionDataRef,
    storeMappingSettings,
    providerKey,
    setSelectionData,
    toggleCheckbox,
  }) => {
    const product = productList[index];
    const id = product?.marketplace_product_ref;

    const [rowSelection, setRowSelection] = useState(
      () => selectionDataRef.current[id] || {},
    );

    const [markupPercentage, setMarkupPercentage] = useState(
      () =>
        selectionDataRef.current[id]?.markup_override ??
        storeMappingSettings?.price_markup_percentage ??
        0,
    );

    const isChecked = selectedProducts.is_select_all
      ? !selectedProducts.exclude_selected_ids[id]
      : !!selectedProducts.selected_ids[id];

    useEffect(() => {
      setRowSelection(selectionDataRef.current[id] || {});
      setMarkupPercentage(
        selectionDataRef.current[id]?.markup_override ??
          storeMappingSettings?.price_markup_percentage ??
          0,
      );
    }, [id, isChecked, storeMappingSettings?.price_markup_percentage]);

    if (!product) return null;

    const hasLinkedProduct = Boolean(
      rowSelection?.product_id ||
      rowSelection?.variant_id ||
      rowSelection?.service_id ||
      rowSelection?.lumi_object_id,
    );

    const selectedObjectId =
      rowSelection?.lumi_object_id ||
      rowSelection?.product_id ||
      rowSelection?.variant_id ||
      rowSelection?.service_id;

    const matchedProduct = selectedObjectId
      ? lumiProductList?.find(
          (item) => `${item?.lumi_object_id}` === `${selectedObjectId}`,
        )
      : null;

    const selectedOption =
      matchedProduct || rowSelection?.lumi_product_name
        ? {
            label:
              matchedProduct?.lumi_product_name ||
              rowSelection?.lumi_product_name,
            value: matchedProduct?.lumi_object_id || selectedObjectId,
          }
        : null;

    return (
      <div
        style={{
          ...style,
          zIndex: productList?.length - index,
        }}
      >
        <div className={styles.productItem}>
          <div
            className={`${styles.select} d-flex align-items-center`}
            style={{ gap: "20px" }}
          >
            <span className="purple--text">{index + 1}).</span>
            <primaryComponents.Checkbox
              name="marketPlaceMapping"
              id={id}
              isChecked={isChecked}
              onChange={() => toggleCheckbox(id)}
            >
              <span className="d-block mt-1">
                {product?.marketplace_product_name}
              </span>
            </primaryComponents.Checkbox>

            <span
              className={`ml-auto success--text ${styles.link}`}
              style={{ fontStyle: "italic" }}
            >
              Link With <ArrowRight />
            </span>
          </div>

          <div className={`d-flex ${styles.select}`} style={{ gap: "10px" }}>
            <div style={{ width: "100%", maxWidth: "250px" }}>
              <primaryComponents.SelectField
                value={selectedOption}
                giveControl={false}
                placeholder="Select an item"
                options={lumiProductList}
                nameKey={"lumi_product_name"}
                idKey={"lumi_object_id"}
                floatError={false}
                isDisabled={!isChecked}
                onChange={(value, label, obj) => {
                  const key =
                    obj?.lumi_object_type === "product"
                      ? "product_id"
                      : obj?.lumi_object_type === "variant"
                        ? "variant_id"
                        : "service_id";

                  const newSelection = {
                    ...selectionDataRef.current[id],
                    product_id: undefined,
                    variant_id: undefined,
                    service_id: undefined,
                    [key]: value,
                    lumi_object_id: value,
                    lumi_product_name: label,
                    marketplace_product_name: product.marketplace_product_name,
                  };

                  setSelectionData(id, newSelection);
                  setRowSelection(newSelection);
                }}
              />
            </div>

            {providerKey === "chowdeck" ? (
              <div style={{ maxWidth: "130px" }}>
                <primaryComponents.InputField
                  name={"markup_override"}
                  placeholder={"Price markup e.g 10%"}
                  value={
                    markupPercentage ??
                    storeMappingSettings?.price_markup_percentage
                  }
                  type="number"
                  floatError={false}
                  classNames="white"
                  onChange={({ target: { value } }) => {
                    setMarkupPercentage(value);
                    const newSelection = {
                      ...selectionDataRef.current[id],
                      markup_override: value,
                    };
                    setSelectionData(id, newSelection);
                    setRowSelection(newSelection);
                  }}
                  isDisabled={
                    !isChecked ||
                    !hasLinkedProduct ||
                    !storeMappingSettings?.sync_product_price
                  }
                />
              </div>
            ) : null}
          </div>
        </div>

        <hr />
      </div>
    );
  },
);
